import React from "react";
import { AppConfig } from "../../../app-state";
export const TermsAndConditions = () => {
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "cms-single-panel cms-article" },
            React.createElement("h1", null, "Auk\u010Dn\u00ED \u0159\u00E1d"),
            React.createElement("p", null,
                "Auk\u010Dn\u00ED \u0159\u00E1d poskytovatele auk\u010Dn\u00EDho syst\u00E9mu spole\u010Dnosti ",
                AppConfig.companyName,
                " je k dispozici ke sta\u017Een\u00ED ve form\u00E1tu PDF."),
            React.createElement("a", { className: "pdf-doc", href: "/asset/doc/aukcni-rad.pdf", target: "_blank" },
                React.createElement("span", { className: "link" }, "Auk\u010Dn\u00ED \u0159\u00E1d"),
                React.createElement("span", { className: "format" }, "Form\u00E1t .PDF - Acrobat Reader, 320kb"),
                React.createElement("span", { className: "description" }, "Upravuje vz\u00E1jemn\u00E1 pr\u00E1va a povinnosti smluvn\u00EDch stran.")))));
};
